const formatActivityLabel = (activityType) => {
    const value = String(activityType || '').trim();
    if (!value) {
        return 'activity';
    }

    return value.replace(/_/g, ' ');
};

module.exports = {
    formatActivityLabel
};
